module.exports = __webpack_public_path__ + "img/ga-junk-boat-2013.fcb6fbc6.jpg";